import typeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import { SET_INPC_FILTERS, SET_INPC_PAGINATION, GET_INPC, RESET_INPC_LIST } from 'inpc/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const inpc = new schema.Entity('inpc');

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getRejected = (state) => ({ ...state, isLoading: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize({ inpc: payload.records }, { inpc: [inpc] }),
});

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['year'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { inpc: {} },
  result: { inpc: [] },
};

const reducers = {
  [RESET_INPC_LIST]: reset,
  [SET_INPC_FILTERS]: setFilters,
  [SET_INPC_PAGINATION]: setPagination,
  [GET_INPC]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
};

export default typeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/reducers/inpc_list_reducers.js